import React, { useState } from 'react';
import cx from 'classnames';
import { Trans } from '@elevio/kb-kit/lib/components/trans';
import { useLanguages } from '@elevio/kb-kit/lib/hooks';
import SearchInput from '../searchInput/SearchInput';
import { Logo } from '../Logo';
import LoginLogout from '../LoginLogout';
import LanguagePicker from '../LanguagePicker';
import "./header.scss";
function Header({ children, className, hideSearch }) {
  const { supportedLanguages, selectedLanguage, setCurrentLanguageId } =
    useLanguages();
  return (
    <header className={cx('header', className)} data-testid="header">
      <div className="container">
        <div className="header-row">
          <a href="/" className="logo">

            
            <svg id="saxo_blog" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 335.723 110.941" width="335.723" height="110.941">
              <path fill="#c51a24" d="M0 0h335.723v110.941H0z"/>
              <path fill="#fff" d="M47.818 64.81h9.378c5.092 6.849 10.932 8.94 17.64 8.94 4.13 0 6.026-1.604 6.026-4.28 0-3.634-2.567-5.026-13.172-7.486-12.615-2.992-19.203-6.846-19.203-16.258 0-9.2 7.48-16.795 19.648-16.795 8.85 0 15.522 3.106 18.212 6.521v-6.53h9.476v16.24h-9.38c-3.845-5.63-10.31-8.314-15.628-8.314-4.465 0-5.918 1.82-5.918 4.28 0 3.316 2.68 4.386 12.84 6.846 11.276 2.78 19.872 6.311 19.872 16.9 0 9.2-7.15 17.01-20.43 17.01-10.17 0-16.3-2.646-19.888-6.885l.003 6.886h-9.48V64.81zm210.516-35.88c-16.26 0-29.375 10.752-29.375 26.476s13.112 26.476 29.37 26.476c16.26 0 29.38-10.75 29.38-26.472s-13.117-26.476-29.378-26.476m0 45.036c-6.204 0-9.696-4.976-9.696-18.56 0-13.585 3.492-18.561 9.696-18.561 6.205 0 9.697 4.976 9.697 18.561s-3.49 18.56-9.697 18.56m-101.8-1.565h-4.337V47.608c0-10.483-4.92-18.612-21.71-18.612-11.112 0-25.352 3.1-25.352 13.479a8.61 8.61 0 0 0 8.61 8.61c4.753 0 8.607-3.856 8.607-8.61 0-2.5-1.07-4.74-2.765-6.313 0 0 1.517-.423 4.252-.423 6.727 0 10.608 4.38 10.608 10.465v5.707c-13.213 0-23.43 3.504-27.814 7.888-2.14 2.14-3.53 5.243-3.53 8.558 0 8.45 6.955 13.585 15.83 13.585 12.21 0 17.01-8.979 17.01-8.979h.534l.005 8.979h20.056v-9.54zm-22.09-10.36c0 6.574-2.91 9.846-7.063 9.846-4.386 0-6.095-2.885-6.095-5.88 0-3.575 2.216-6.845 8.343-7.97 2.672-.535 3.85-.644 4.814-.857v4.867zm34.66-23.51L184.1 56.06l-16.418 16.31h-5.658v9.503h24.443v-9.496h-6.865l9.98-9.906 8.466 9.91h-6.12v9.496h34.346V72.37h-6.466L204.51 54.48l16.074-15.944h5.69v-9.622H201.81v9.627h6.817l-9.6 9.524-8.14-9.524h5.48v-9.627l-34.34.004v9.618z"/>
            </svg>



          </a>
            
          <SearchInput placeholder={"Søg efter hjælp..."} data-testid="search-input" className="input-rounded"/>

          <div className="profile-nav">
            <a href='https://www.saxo.com/dk/medlemskaber' className="profile-nav-item icon icon-saxo-s">
              <span className="profile-nav-underline">Bliv medlem</span>
            </a>

            <a href='https://www.saxo.com/dk/profile' className="profile-nav-item icon icon-profile">
              <span className="profile-nav-underline">Mit Saxo</span>
            </a>

            <a href='https://www.saxo.com/dk' className="profile-nav-item icon icon-home">
              <span className="profile-nav-underline">Gå til Saxo</span>
            </a>
          </div>
        </div>
      </div>
    </header>
  );
}
export default Header;
